import React from 'react';
import { CTAButton } from '../CTAButton';
const DOCTOR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/e6853b45-1ce9-457c-8369-69189cdccc9f.jpg';
export function About() {
  return <section className="w-full bg-cream px-4 py-14" aria-labelledby="sobre" data-id="element-51" data-mp="12r6paq8uc9d4">
      <div className="mx-auto w-full max-w-4xl" data-id="element-52" data-mp="ypl50jtz8ssw">
        <div className="grid gap-7 md:grid-cols-[280px_1fr] md:items-start" data-id="element-53" data-mp="yptjuh9nu86q">
          <div className="mx-auto w-full max-w-[280px]" data-id="element-54" data-mp="b0shnbrf7t9w">
            <img src={DOCTOR_IMAGE} alt="Retrato de la Dra. Karito, médica creadora de Ruta Hipertensión" className="w-full rounded-3xl object-cover shadow-xl shadow-navy/10" data-id="element-55" data-mp="60mlpje4bkm0" />
            <p className="mt-3 text-center text-sm font-extrabold text-navy" data-id="element-56" data-mp="f12m2jzkebmn">
              Dra. Karito
            </p>
            <p className="text-center text-xs text-navy/60" data-id="element-57" data-mp="3nftdmwg4vuqf">
              Creadora de Ruta Hipertensión
            </p>
          </div>

          <div data-id="element-58" data-mp="3jdq0829wmg2i">
            <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-59" data-mp="3398hsd36y953">
              Sobre la autora
            </p>
            <h2 id="sobre" className="mt-3 font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-60" data-mp="3879zatkyy0eg">
              No faltaba conocimiento. Faltaba una forma práctica de aplicarlo.
            </h2>
            <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-navy/75" data-id="element-61" data-mp="2kae12yk62yma">
              <p data-id="element-62" data-mp="2kcqs017wkjbh">
                Durante años observé el mismo problema una y otra vez: médicos
                comprometidos con sus pacientes, pero obligados a tomar decisiones
                importantes mientras intentaban recordar recomendaciones dispersas
                entre diferentes guías.
              </p>
              <p data-id="element-63" data-mp="9il4dxatj817">
                Por eso nació Ruta Hipertensión. No como otro manual para guardar en
                una carpeta, sino como una herramienta diseñada para acompañarte
                durante la consulta y ayudarte a responder la pregunta que realmente
                importa:{' '}
                <span className="font-semibold text-navy" data-id="element-64" data-mp="25lpu98ia5g94">
                  ¿cuál es el siguiente paso con este paciente?
                </span>
              </p>
              <p data-id="element-65" data-mp="2jj4qaw31gma2">
                Cada algoritmo, protocolo y plantilla fue creado para simplificar
                decisiones complejas y convertir la evidencia científica en acciones
                concretas. Cuando tienes una ruta clara, cambia la forma en que
                ejerces la medicina y también la confianza con la que tus pacientes
                te ven.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8" data-id="element-66" data-mp="1vvwia6e86z4c">
          <CTAButton label="Quiero la ruta de la Dra. Karito" data-id="element-67" data-mp="1vuuy9cf8f2ah" />
        </div>
      </div>
    </section>;
}